var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _rect10, _path3, _path4, _path5, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 176,
    viewBox: "0 0 213 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.295,
    y: 159.609,
    width: 48.554,
    height: 18.148,
    rx: 9.074,
    transform: "rotate(-30 36.295 159.609)",
    fill: "#E7E7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.855,
    y: 110.832,
    width: 24.17,
    height: 18.127,
    rx: 9.064,
    transform: "rotate(-30 11.855 110.832)",
    fill: "#E7E7E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151.854,
    y: 9.074,
    width: 18.148,
    height: 18.148,
    rx: 9.074,
    transform: "rotate(-30 151.854 9.074)",
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.162 70.096a9.074 9.074 0 008.948 15.787l28.018-16.176a9.074 9.074 0 019.133 15.682l50.628-29.23.07-.041-1.422.82a9.074 9.074 0 11-9.073-15.715l6.815-3.935a9.074 9.074 0 00-9.228-15.625l-83.89 48.433zm52.843 53.31a9.074 9.074 0 009.074 15.717l67.34-38.879a9.074 9.074 0 003.321-12.395 9.074 9.074 0 00-12.395-3.322l-67.34 38.879zm36.517-42.038l-.522.302c.088-.05.176-.097.264-.143a9.074 9.074 0 009.063 15.7 8.789 8.789 0 01-.359.22l-56.204 32.448a2.36 2.36 0 01-.07.04l12.248-7.071a9.073 9.073 0 003.321-12.395 9.073 9.073 0 00-12.395-3.321L62.43 123.566a9.074 9.074 0 01-8.946-15.788L165.267 43.24a9.074 9.074 0 019.074 15.716l-7.599 4.388-.102.058-31.017 17.907-.101.06z",
    fill: "#E7E7E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.433,
    cy: 106.954,
    r: 4.708,
    stroke: "#D0D0D0",
    strokeWidth: 2.266
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.644,
    cy: 46.73,
    r: 3.499,
    stroke: "#D0D0D0",
    strokeWidth: 2.266
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.105,
    cy: 161.535,
    r: 3.499,
    stroke: "#D0D0D0",
    strokeWidth: 2.266
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129.109,
    y: 4.633,
    width: 11.279,
    height: 2.014,
    rx: 1.007,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 135.756,
    width: 11.279,
    height: 2.014,
    rx: 1.007,
    transform: "rotate(90 135.756 0)",
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168.184,
    y: 134.242,
    width: 8.459,
    height: 2.014,
    rx: 1.007,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.422,
    y: 131.121,
    width: 8.459,
    height: 2.014,
    rx: 1.007,
    transform: "rotate(90 173.422 131.121)",
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 93.356,
    width: 8.459,
    height: 2.014,
    rx: 1.007,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.895,
    y: 90.234,
    width: 8.459,
    height: 2.014,
    rx: 1.007,
    transform: "rotate(90 12.895 90.234)",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.541 46.675v19.35l7.21.19V56.35c-.38-11.066 4.059-32.972 24.851-32.061 25.991 1.138 25.422 23.714 25.612 26.56.189 2.845 7.019 5.122 7.588-1.708s-6.071-31.302-33.2-32.061c-21.703-.607-30.417 19.477-32.061 29.595z",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 54.391,
    y: 66.986,
    width: 99.708,
    height: 66.103,
    rx: 9.475,
    fill: "#fff",
    stroke: "#BEBEBE",
    strokeWidth: 2.707
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.391 49.631c0-13.888-11.259-25.147-25.147-25.147-13.888 0-25.146 11.259-25.146 25.147v16.371",
    stroke: "#BEBEBE",
    strokeWidth: 2.707
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.705 49.626c0-17.928-14.533-32.462-32.462-32.462-17.928 0-32.462 14.534-32.462 32.462V66M129.392 49.631a3.657 3.657 0 107.315 0",
    stroke: "#BEBEBE",
    strokeWidth: 2.707
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 68.34h39.865a8.1 8.1 0 018.1 8.1v47.183a8.1 8.1 0 01-8.1 8.1h-39.865V68.34z",
    fill: "#ECECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 99.672,
    y: 88.262,
    width: 9.144,
    height: 23.775,
    rx: 4.572,
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.bd7d67a4.svg";
export { ForwardRef as ReactComponent };